<script>
import CompRabInfo from '@/src/router/views/pages/transaksi/proyek/rab/comp-rab-info.vue'
import { crudMethods } from '@/src/state/helpers'
import moment from 'moment'

export default {
  components: { CompRabInfo },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      apiUrl: '/web/transaksi/proyek',
      title: 'RAB',
      modalInput: false,
      modalUpload: false,
      modalPreview: false,
      uraianJustifikasi: '',
      volume: '',
      periode: '',
      satuan: 'unit',
      sph: '0',
      sphKali: '',
      spk: '0',
      spkKali: '',
      fileDokumen: null,
      noDokumen: '',
      // pkId: this.$route.params.id ? this.$route.params.id : '',
      listKali: [
        {
          value: 'volume',
          text: 'VOLUME',
        },
        {
          value: 'periode',
          text: 'PERIODE',
        },
        {
          value: 'all',
          text: 'ALL',
        },
        {
          value: null,
          text: 'NONE',
        },
      ],
      listSatuan: [
        {
          value: 'unit',
          text: 'UNIT',
        },
        {
          value: 'orang',
          text: 'ORANG',
        },
        {
          value: 'paket',
          text: 'PAKET',
        },
        {
          value: 'lot',
          text: 'LOT',
        },
        {
          value: 'titik',
          text: 'TITIK',
        },
      ],
      listPeriode: [],
      items: [],
      detail: {},
      pkId: '',
      pkId2: '',
      idHeader: '',
      nomor: '',
      dokumenKL: false,
      loading: false,
    }
  },
  computed: {
    checkAuthorized() {
      return (
        this.user.role === 'ROOT' ||
        this.user.role === 'ADMIN' ||
        this.user.role === 'KABAG-SALES-DELIVERY'
      )
    },
    checkValidation() {
      return this.uraianJustifikasi === ''
    },
    checkValidationFile() {
      return this.fileDokumen === null || this.noDokumen === ''
    },
    handleSPKKali() {
      let val = ''
      if (this.spkKali === 'volume' || this.spkKali === 'periode') {
        val = parseInt(this.spk) * parseFloat(this.$data[this.spkKali])
      } else if (this.spkKali === null) {
        val = null
      } else {
        val =
          parseInt(this.spk) * parseFloat(this.volume) * parseInt(this.periode)
      }
      return isNaN(val) ? 0 : val
    },
    handleSPHKali() {
      let val = ''
      if (this.sphKali === 'volume' || this.sphKali === 'periode') {
        val = parseInt(this.sph) * parseFloat(this.$data[this.sphKali])
      } else if (this.sphKali === null) {
        val = null
      } else {
        val =
          parseInt(this.sph) * parseFloat(this.volume) * parseInt(this.periode)
      }

      return isNaN(val) ? 0 : val
    },
    marginPresentase() {
      const spk = this.items.reduce(
        (a, b) =>
          a +
          (b['spk'] *
            (b['spk_kali'] !== 'all'
              ? b[b['spk_kali']]
              : b['volume'] * b['periode']) || 0),
        0
      )

      const sph = this.items.reduce(
        (a, b) =>
          a +
          (b['sph'] *
            (b['sph_kali'] !== 'all'
              ? b[b['sph_kali']]
              : b['volume'] * b['periode']) || 0),
        0
      )

      let val = (spk - sph) / sph

      if (spk === 0) return '-'

      if (isNaN(val)) {
        return '0%'
      } else {
        return (val * 100).toFixed(2) + '%'
      }
    },
    margin() {
      const spk = this.items.reduce(
        (a, b) =>
          a +
          (b['spk'] *
            (b['spk_kali'] !== 'all'
              ? b[b['spk_kali']]
              : b['volume'] * b['periode']) || 0),
        0
      )

      const sph = this.items.reduce(
        (a, b) =>
          a +
          (b['sph'] *
            (b['sph_kali'] !== 'all'
              ? b[b['sph_kali']]
              : b['volume'] * b['periode']) || 0),
        0
      )

      let val = spk - sph

      return val
    },
  },
  // watch: {
  //   sphKali: {
  //     handler: function (newVal, oldval) {
  //       if (newVal !== oldval) {
  //         if (newVal === null) this.sph = ''
  //       }
  //     },
  //     deep: true,
  //   },
  //   spkKali: {
  //     handler: function (newVal, oldval) {
  //       if (newVal !== oldval) {
  //         if (newVal === null) this.spk = ''
  //       }
  //     },
  //     deep: true,
  //   },
  // },
  mounted() {
    this.getDetail()
    this.getList()
    for (var i = 1; i <= 12; i++) {
      let obj = {
        value: i,
        text: i,
      }

      this.listPeriode.push(obj)
    }
  },

  methods: {
    ...crudMethods,
    saveRAB() {
      this.loading = true
      let sph = null
      let spk = null

      if (this.sphKali === null && this.sph === '') {
        sph = null
      } else if (this.sphKali === null && this.sph === 0) {
        sph = 0
      } else if (this.sphKali !== null) {
        sph = this.sph
      }

      if (this.spkKali === null && this.spk === '') {
        spk = null
      } else if (this.spkKali === null && this.spk === 0) {
        spk = 0
      } else if (this.spkKali !== null) {
        spk = this.spk
      }

      let body = {
        uraian_justifikasi: this.uraianJustifikasi,
        volume: this.volume === null || this.volume === '' ? null : this.volume,
        periode:
          this.periode === null || this.periode === '' ? null : this.periode,
        satuan:
          this.satuan === null || this.satuan === ''
            ? null
            : this.satuan.toUpperCase(),
        sph: sph,
        sph_kali: this.sphKali,
        spk: spk,
        spk_kali: this.spkKali,
        id_header:
          this.idHeader === null || this.idHeader === '' ? null : this.idHeader,
        nomor: this.nomor === null || this.nomor === '' ? null : this.nomor,
      }

      let action = 'insertData'
      let url = `${this.apiUrl}/${this.$route.params.id}/rab`

      if (this.pkId !== '') {
        action = 'updateData'
        url = `${this.apiUrl}/${this.$route.params.id}/rab/${this.pkId}`
      }

      this[action]({ url: url, body: body })
        .then((response) => {
          this.toast(
            'b-toaster-bottom-right',
            true,
            ' Berhasil Diupdate',
            'success'
          )
          this.loading = false

          this.getList()
          this.clearForm()
          this.modalInput = false
        })
        .catch((err) => {
          this.loading = false
          let message = JSON.parse(err.response.request.response)
          this.messageError = message.message
          this.modalError = true
        })
    },
    showModalTambah() {
      this.clearForm()
      this.modalInput = true
    },
    clearForm() {
      this.uraianJustifikasi = ''
      this.spk = ''
      this.spkKali = ''
      this.sph = ''
      this.sphKali = ''
      this.volume = ''
      this.periode = ''
      this.satuan = ''
      this.pkId = ''
      this.idHeader = ''
      this.nomor = ''
    },
    getList() {
      this.listData({
        url: `web/transaksi/proyek/${this.$route.params.id}/rab`,
      }).then((response) => {
        const { data } = response.data
        let items = []
        let no = 1
        data.forEach((item) => {
          let obj = {
            no: no,
            proyek_id: item.proyek_id,
            id: item.id,
            uraian_justifikasi: item.uraian_justifikasi,
            volume: item.volume,
            periode: item.periode,
            satuan: item.satuan,
            sph: item.sph,
            sph_kali: item.sph_kali,
            spk: item.spk,
            spk_kali: item.spk_kali,
            proyek_id_header: item.proyek_id_header,
            id_header: item.id_header,
            type_field: item.type_field,
            type_sub: 0,
          }

          if (item.subs && item.subs.length > 0) {
            const rowspanSph = item.subs.filter((x) => x.sph === null).length
            const rowspanSpk = item.subs.filter((x) => x.spk === null).length
            const rowspanVolume = item.subs.filter((x) => x.volume === null)
              .length
            const rowspanPeriode = item.subs.filter((x) => x.periode === null)
              .length
            const rowspanSatuan = item.subs.filter((x) => x.satuan === null)
              .length

            obj.rowspan_sph = rowspanSph + 1
            obj.rowspan_spk = rowspanSpk + 1
            obj.rowspan_volume = rowspanVolume + 1
            obj.rowspan_periode = rowspanPeriode + 1
            obj.rowspan_satuan = rowspanSatuan + 1
          }

          items.push(obj)

          item.subs.forEach((sub1) => {
            let obj = {
              proyek_id: sub1.proyek_id,
              id: sub1.id,
              uraian_justifikasi: sub1.uraian_justifikasi,
              volume: sub1.volume,
              periode: sub1.periode,
              satuan: sub1.satuan,
              sph: sub1.sph,
              sph_kali: sub1.sph_kali,
              spk: sub1.spk,
              spk_kali: sub1.spk_kali,
              proyek_id_header: sub1.proyek_id_header,
              id_header: sub1.id_header,
              type_field: sub1.type_field,
              type_sub: 1,
            }
            if (sub1.subs && sub1.subs.length > 0) {
              const rowspanSph = sub1.subs.filter((x) => x.sph === null).length
              const rowspanSpk = sub1.subs.filter((x) => x.spk === null).length
              const rowspanVolume = sub1.subs.filter((x) => x.volume === null)
                .length
              const rowspanPeriode = sub1.subs.filter((x) => x.periode === null)
                .length
              const rowspanSatuan = sub1.subs.filter((x) => x.satuan === null)
                .length

              obj.rowspan_sph = rowspanSph + 1
              obj.rowspan_spk = rowspanSpk + 1
              obj.rowspan_volume = rowspanVolume + 1
              obj.rowspan_periode = rowspanPeriode + 1
              obj.rowspan_satuan = rowspanSatuan + 1
            }

            items.push(obj)
            sub1.subs.forEach((sub2) => {
              let obj = {
                proyek_id: sub2.proyek_id,
                id: sub2.id,
                uraian_justifikasi: sub2.uraian_justifikasi,
                volume: sub2.volume,
                periode: sub2.periode,
                satuan: sub2.satuan,
                sph: sub2.sph,
                sph_kali: sub2.sph_kali,
                spk: sub2.spk,
                spk_kali: sub2.spk_kali,
                proyek_id_header: sub2.proyek_id_header,
                id_header: sub2.proyek_id,
                type_field: sub2.type_field,
                type_sub: 2,
              }

              if (sub2.subs && sub2.subs.length > 0) {
                const rowspanSph = sub2.subs.filter((x) => x.sph === null)
                  .length
                const rowspanSpk = sub2.subs.filter((x) => x.spk === null)
                  .length
                const rowspanVolume = sub2.subs.filter((x) => x.volume === null)
                  .length
                const rowspanPeriode = sub2.subs.filter(
                  (x) => x.periode === null
                ).length
                const rowspanSatuan = sub2.subs.filter((x) => x.satuan === null)
                  .length

                obj.rowspan_sph = rowspanSph + 1
                obj.rowspan_spk = rowspanSpk + 1
                obj.rowspan_volume = rowspanVolume + 1
                obj.rowspan_periode = rowspanPeriode + 1
                obj.rowspan_satuan = rowspanSatuan + 1
              }
              items.push(obj)
            })
          })
          no++
        })
        this.items = items
      })
    },
    getDetail() {
      this.listData({
        url: `web/transaksi/proyek/${this.$route.params.id}`,
      }).then((response) => {
        const { data } = response.data
        this.detail = data
      })
    },
    dateFormat(value) {
      moment.locale('id')
      return moment(value).format('DD MMMM YYYY')
    },
    dateFormatIDN(value) {
      moment.locale('id')
      return moment(value, 'DD-MM-YYYY').format('DD MMMM YYYY')
    },
    handleSPK(e) {
      this.spk = e
    },
    handleSPH(e) {
      this.sph = e
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault()
      }
    },
    downloadRAB() {
      this.downloadData({
        url: `web/transaksi/proyek/${this.$route.params.id}/rab-data`,
      }).then((response) => {
        // console.log(response)
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'data-rab.pdf')
        document.body.appendChild(link)
        link.click()
      })
    },
    exportRAB() {
      this.downloadData({
        url: `web/export/rab?proyek_id=${this.$route.params.id}`,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'data-rab.xlsx')
        document.body.appendChild(link)
        link.click()
      })
    },
    showData(id) {
      this.pkId = id
      this.getData({
        url: `web/transaksi/proyek/${this.$route.params.id}/rab/${id}`,
      }).then((response) => {
        const { data } = response.data
        this.uraianJustifikasi = data.uraian_justifikasi
        this.volume = data.volume
        this.periode = data.periode
        this.spkKali = data.spk_kali
        this.sphKali = data.sph_kali
        this.sph = data.sph == null ? '' : data.sph
        this.spk = data.spk == null ? '' : data.spk
        this.satuan = data.satuan
        this.modalInput = true
      })
    },
    formatBytes(bytes, decimals = 0) {
      if (bytes === 0) return '0 GB'
      if (isNaN(parseInt(bytes))) return bytes
      if (typeof bytes === 'string') bytes = parseInt(bytes)
      if (bytes === 0) return '0'
      const k = 1000
      const dm = decimals + 1 || 3
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`
    },
    changeFile(event) {
      this.fileDokumen = event.target.files[0]
      if (this.fileDokumen.size > 300000) {
        alert(
          'File yang anda upload Terlalu Besar (Maksimal 500kb) ' +
            'Ukuran File yang anda kirim ' +
            this.formatBytes(this.fileDokumen.size)
        )
        this.fileDokumen = null
        this.$refs.fileDokumen = ''
      }
    },
    addChild(id) {
      this.clearForm()
      this.idHeader = id

      this.modalInput = true
    },
    showModalUpload(id) {
      this.pkId = id
      this.modalUpload = true
    },
    removeData(id) {
      this.$bvModal
        .msgBoxConfirm(`hapus data ${this.title.toLowerCase()} ini?`, {
          title: 'Mohon Konfirmasi',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'YA',
          cancelTitle: 'TIDAK',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.deleteData({
              url: `${this.apiUrl}/${this.$route.params.id}/rab/${id}`,
            })
              .then((response) => {
                this.getList()
                this.toast(
                  'b-toaster-bottom-right',
                  true,
                  ' Berhasil Dihapus',
                  'success'
                )
              })
              .catch((err) => {
                this.loading = false
                let message = JSON.parse(err.response.request.response)
                this.messageError = message.message
                this.toast(
                  'b-toaster-bottom-right',
                  true,
                  ' Tidak Dapat Dihapus',
                  'danger'
                )
              })
          }
        })
    },
    changeSpkKali() {
      if (this.spkKali === null) this.spk = ''
    },
    changeSphKali() {
      if (this.sphKali === null) this.sph = ''
    },
    toast(toaster, append = false, body, variant) {
      this.$bvToast.toast(`Data ${this.title} ${body}`, {
        title: this.title,
        toaster: toaster,
        solid: true,
        appendToast: append,
        variant: variant,
      })
    },
  },
}
</script>

<template>
  <div class="row d-print-none">
    <div class="col-sm-12">
      <div class="row mb-3">
        <div class="col-sm-6">
          <h5 class="m-0 font-weight-bold text-dark">
            {{ title }}
          </h5>

          <small class="text-muted">
            Buat dan kelola RAB {{ detail.nama_proyek }}
          </small>
        </div>
        <div class="d-flex col-sm-6 justify-content-end gap-4">
          <b-dropdown
            text="Aksi Lainnya"
            variant="outline-primary"
            class="d-flex flex-col justify-content-center align-items-center height-36-px"
            right
          >
            <b-dropdown-item @click="downloadRAB">
              <i class="fa fa-download mr-1"></i>
              Download RAB
            </b-dropdown-item>

            <b-dropdown-item @click="modalPreview = true">
              <i class="fa fa-search mr-1"></i>
              Preview RAB
            </b-dropdown-item>

            <b-dropdown-item @click="exportRAB">
              <i class="fa fa-file-excel mr-1"></i>
              Export RAB
            </b-dropdown-item>
          </b-dropdown>

          <button
            v-if="user.role !== 'ADMINISTRASI'"
            class="btn btn-primary d-flex flex-col justify-content-center align-items-center height-36-px"
            @click="showModalTambah"
          >
            <span class="d-flex align-items-center gap-5 width-100">
              <i class="fa fa-plus-circle"></i>
              Tambah RAB
            </span>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <CompRabInfo
            :detail="detail"
            :items="items"
            :margin-presentase="marginPresentase"
          />
        </div>
      </div>
    </div>
    <div class="col-sm-12">
      <div class="table-responsive rab-table-wrapper">
        <table class="table table-sm table-bordered rab-table">
          <thead>
            <tr class="header-lvl-1">
              <th rowspan="2" class="sticky-col-1">
                No
              </th>

              <th rowspan="2" class="sticky-col-uraian">
                Uraian
              </th>

              <th rowspan="2">
                VOL
              </th>

              <th rowspan="2">
                Periode
              </th>

              <th rowspan="2">
                SAT
              </th>

              <th colspan="2" class="text-center">
                Harga SPH Vendor
              </th>

              <th colspan="2" class="text-center">
                Harga Penawaran SPK
              </th>

              <th rowspan="2" class="text-center sticky-col-last">
                Aksi
              </th>
            </tr>

            <tr class="header-lvl-2">
              <th>
                HARGA
              </th>

              <th>
                JUMLAH
              </th>

              <th>
                HARGA
              </th>

              <th>
                JUMLAH
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item, index) in items" :key="index">
              <!-- NO -->
              <td class="text-center sticky-col-1">
                {{ item.no }}
              </td>

              <!-- URAIAN -->
              <td class="th-td-35 sticky-col-uraian">
                {{ item.uraian_justifikasi }}
              </td>

              <!-- VOLUME -->
              <td
                v-if="
                  item.volume !== null ||
                    (item.proyek_id_header === null && item.id_header === null)
                "
                class="text-center"
                :rowspan="item.rowspan_volume"
              >
                {{ item.volume }}
              </td>

              <!-- PERIODE -->
              <td
                v-if="
                  item.periode !== null ||
                    (item.proyek_id_header === null && item.id_header === null)
                "
                class="text-center"
                :rowspan="item.rowspan_periode"
              >
                {{ item.periode }}
              </td>

              <!-- SATUAN -->
              <td
                v-if="
                  item.satuan !== null ||
                    (item.proyek_id_header === null && item.id_header === null)
                "
                class="text-center"
                :rowspan="item.rowspan_satuan"
              >
                {{ item.satuan !== null ? item.satuan.toUpperCase() : '' }}
              </td>

              <!-- SPH HARGA -->
              <td
                v-if="
                  item.sph !== null ||
                    (item.proyek_id_header === null && item.id_header === null)
                "
                class="text-center"
                :rowspan="item.rowspan_sph"
              >
                {{
                  item.sph !== null && item.sph !== 0
                    ? `Rp${item.sph
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
                    : ''
                }}
              </td>

              <!-- SPH JUMLAH -->
              <td
                v-if="
                  item.sph !== null ||
                    (item.proyek_id_header === null && item.id_header === null)
                "
                class="text-center"
                :rowspan="item.rowspan_sph"
              >
                {{
                  item.sph !== null && item.sph !== 0
                    ? `Rp${(
                        item.sph *
                        (item.sph_kali !== 'all'
                          ? item[item.sph_kali]
                          : item.volume * item.periode)
                      )
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
                    : ''
                }}
              </td>

              <!-- SPK HARGA -->
              <td
                v-if="
                  item.spk !== null ||
                    (item.proyek_id_header === null && item.id_header === null)
                "
                class="text-center"
                :rowspan="item.rowspan_spk"
              >
                {{
                  item.spk !== null && item.spk !== 0
                    ? `Rp${item.spk
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
                    : ''
                }}
              </td>

              <!-- SPK JUMLAH -->
              <td
                v-if="
                  item.spk !== null ||
                    (item.proyek_id_header === null && item.id_header === null)
                "
                class="text-center"
                :rowspan="item.rowspan_spk"
              >
                {{
                  item.spk !== null && item.spk !== 0
                    ? `Rp${(
                        item.spk *
                        (item.spk_kali !== 'all'
                          ? item[item.spk_kali]
                          : item.volume * item.periode)
                      )
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
                    : ''
                }}
              </td>

              <!-- ACTION -->
              <td class="text-center sticky-col-last">
                <template v-if="!dokumenKL">
                  <button
                    v-if="checkAuthorized"
                    class="
                  btn btn-sm btn-outline-primary
                  pr-2
                  pl-2
                  rounded-0
                  font-size-10
                  mr-1
                "
                    @click="showData(item.id)"
                  >
                    <i class="uil uil-edit"></i>
                  </button>

                  <button
                    v-if="checkAuthorized"
                    class="
                  btn btn-sm btn-outline-danger
                  pr-2
                  pl-2
                  rounded-0
                  font-size-10
                  mr-1
                "
                    @click="removeData(item.id)"
                  >
                    <i class="uil uil-trash"></i>
                  </button>

                  <button
                    v-if="item.type_sub < 2"
                    class="
                  btn btn-sm btn-primary
                  pr-2
                  pl-2
                  rounded-0
                  font-size-10
                "
                    @click="addChild(item.id)"
                  >
                    <i class="uil uil-plus"></i>
                  </button>
                </template>

                <template v-if="dokumenKL">
                  Dokumen Fixed
                </template>
              </td>
            </tr>

            <!-- TOTAL -->
            <tr class="rab-total-row">
              <td class="text-center sticky-col-1"></td>

              <td class="th-td-35 sticky-col-uraian"></td>

              <td class="text-center"></td>

              <td class="text-center"></td>

              <td class="text-center"></td>

              <td class="text-center"></td>

              <td class="text-center">
                Rp
                {{
                  items
                    .reduce(
                      (a, b) =>
                        a +
                        (b['sph'] *
                          (b['sph_kali'] !== 'all'
                            ? b[b['sph_kali']]
                            : b['volume'] * b['periode']) || 0),
                      0
                    )
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }}
              </td>

              <td class="text-center"></td>

              <td class="text-center">
                Rp
                {{
                  items
                    .reduce(
                      (a, b) =>
                        a +
                        (b['spk'] *
                          (b['spk_kali'] !== 'all'
                            ? b[b['spk_kali']]
                            : b['volume'] * b['periode']) || 0),
                      0
                    )
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }}
              </td>

              <td class="text-center sticky-col-last"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-modal
      v-model="modalInput"
      title-class="text-center"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
    >
      <div>
        <div class="row">
          <div class="form-group col-sm-12">
            <label>Nomor Urut</label>
            <input
              v-model="nomor"
              type="text"
              class="form-control col-sm-3"
              @keypress="onlyNumber"
            />
          </div>
          <div class="form-group col-sm-12">
            <label
              >Uraian<span
                v-if="uraianJustifikasi === ''"
                class="text-danger font-size-11 font-italic"
                >*Harus Diisi</span
              ></label
            >
            <b-form-textarea
              id="textarea"
              v-model="uraianJustifikasi"
              rows="5"
              max-rows="5"
              no-resize
            ></b-form-textarea>
          </div>
          <div class="form-group col-sm-4">
            <label>Volume</label>
            <input
              v-model="volume"
              type="text"
              class="form-control"
              @keypress="onlyNumber"
            />
          </div>
          <div class="form-group col-sm-4">
            <label>Periode</label>
            <input
              v-model="periode"
              type="text"
              class="form-control"
              @keypress="onlyNumber"
            />
          </div>
          <div class="form-group col-sm-4">
            <label>Satuan</label>
            <input v-model="satuan" class="form-control text-uppercase" />
          </div>
          <div class="form-group col-sm-4">
            <label
              >SPH Kali<span
                v-if="sphKali === ''"
                class="text-danger font-size-11 font-italic"
                >*Harus Dipilih</span
              ></label
            >
            <b-form-select
              v-model="sphKali"
              :options="listKali"
              value-field="value"
              text-field="text"
              @change="changeSphKali"
            >
            </b-form-select>
          </div>
          <div class="form-group col-sm-4">
            <label>Nilai SPH</label>
            <!-- <comma-formatted-number
              :format-options="{ thousand: ',', precision: 0 }"
              :value="sph"
              class="form-control"
              @input="handleSPH"
            /> -->
            <vue-numeric
              v-model="sph"
              currency="Rp"
              separator=","
              class="form-control"
            ></vue-numeric>
          </div>
          <div class="form-group col-sm-4">
            <label>Total SPH</label>
            <input
              class="form-control"
              :value="
                handleSPHKali === null
                  ? null
                  : handleSPHKali
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              readonly
            />
          </div>
          <div class="form-group col-sm-4">
            <label
              >SPK Kali<span
                v-if="spkKali === ''"
                class="text-danger font-size-11 font-italic"
                >*Harus Dipilih</span
              ></label
            >
            <b-form-select
              v-model="spkKali"
              :options="listKali"
              value-field="value"
              text-field="text"
              @change="changeSpkKali"
            >
            </b-form-select>
          </div>
          <div class="form-group col-sm-4">
            <label>Nilai SPK</label>
            <!-- <comma-formatted-number
              :format-options="{ thousand: ',', precision: 0 }"
              :value="spk"
              class="form-control"
              @input="handleSPK"
            /> -->
            <vue-numeric
              v-model="spk"
              currency="Rp"
              separator=","
              class="form-control"
            ></vue-numeric>
          </div>
          <div class="form-group col-sm-4">
            <label>Total SPK</label>
            <input
              class="form-control"
              :value="
                handleSPKKali === null
                  ? null
                  : handleSPKKali
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              readonly
            />
          </div>
        </div>
      </div>
      <div class="text-right">
        <b-button
          class="mr-2"
          type="button"
          variant="outline-primary"
          @click="modalInput = false"
          >Batal / Keluar</b-button
        >
        <b-button
          type="button"
          variant="primary"
          :disabled="checkValidation"
          @click="saveRAB"
          >Simpan RAB</b-button
        >
      </div>
    </b-modal>
    <b-modal
      v-model="modalUpload"
      size=""
      title-class="text-center"
      centered
      no-close-on-backdrop
      title="Upload Dokumen"
    >
      <div>
        <div class="row">
          <div class="form-group col-sm-12">
            <label
              >No Dokumen<span
                v-if="noDokumen === ''"
                class="text-danger font-size-11 font-italic"
                >*Harus Diisi</span
              ></label
            >
            <input v-model="noDokumen" type="text" class="form-control" />
          </div>
          <div class="form-group col-sm-12">
            <label
              >Dokumen<span
                v-if="fileDokumen === ''"
                class="text-danger font-size-11 font-italic"
                >*Harus Diisi</span
              ></label
            >
            <input
              id="fileDokumen"
              ref="fileDokumen"
              class="form-control"
              type="file"
              accept="image/png, image/jpeg, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              @change="changeFile"
            />
          </div>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="outline-primary" @click="modalUpload = false"
          >Close</b-button
        >
        <button
          type="button"
          class="btn btn-primary btn-sm p-2 ml-2 pl-4 pr-4"
          :disabled="checkValidationFile"
          @click="uploadDokumen"
        >
          <i class="uil uil-edit mr-1"></i>Upload
        </button>
      </template>
    </b-modal>
    <b-modal
      v-model="modalPreview"
      size="xl"
      title-class="text-center"
      centered
      no-close-on-backdrop
      title="Preview RAB"
      modal-class="modal-print"
    >
      <h4 class="header-margin font-weight-bold"
        ><center
          >RAB {{ detail.kode_proyek }} {{ detail.nama_proyek }}</center
        ></h4
      >

      <table class="table table-sm table-bordered">
        <thead>
          <tr>
            <th rowspan="2">No</th>
            <th rowspan="2">Uraian</th>
            <th rowspan="2">VOL</th>
            <th rowspan="2">Periode</th>
            <th rowspan="2">SAT</th>
            <th colspan="2" class="text-center">Harga SPH Vendor</th>
            <th colspan="2" class="text-center">Harga Penawaran SPK</th>
          </tr>
          <tr>
            <th>HARGA</th>
            <th>JUMLAH</th>
            <th>HARGA</th>
            <th>JUMLAH</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="index">
            <td class="text-center"> {{ item.no }}</td>
            <td class="th-td-35">{{ item.uraian_justifikasi }}</td>
            <td
              v-if="
                item.volume !== null ||
                  (item.proyek_id_header === null && item.id_header === null)
              "
              class="text-center"
              :rowspan="item.rowspan_volume"
            >
              {{ item.volume }}</td
            >
            <td
              v-if="
                item.periode !== null ||
                  (item.proyek_id_header === null && item.id_header === null)
              "
              class="text-center"
              :rowspan="item.rowspan_periode"
            >
              {{ item.periode }}</td
            >
            <td
              v-if="
                item.satuan !== null ||
                  (item.proyek_id_header === null && item.id_header === null)
              "
              class="text-center"
              :rowspan="item.rowspan_satuan"
            >
              {{ item.satuan !== null ? item.satuan.toUpperCase() : '' }}</td
            >
            <td
              v-if="
                item.sph !== null ||
                  (item.proyek_id_header === null && item.id_header === null)
              "
              class="text-right"
              :rowspan="item.rowspan_sph"
            >
              {{
                item.sph !== null
                  ? `Rp${item.sph
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
                  : ''
              }}</td
            >
            <td
              v-if="
                item.sph !== null ||
                  (item.proyek_id_header === null && item.id_header === null)
              "
              class="text-right"
              :rowspan="item.rowspan_sph"
            >
              {{
                item.sph !== null
                  ? `Rp${(
                      item.sph *
                      (item.sph_kali !== 'all'
                        ? item[item.sph_kali]
                        : item.volume * item.periode)
                    )
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
                  : ''
              }}</td
            >
            <td
              v-if="
                item.spk !== null ||
                  (item.proyek_id_header === null && item.id_header === null)
              "
              class="text-right"
              :rowspan="item.rowspan_spk"
            >
              {{
                item.spk !== null
                  ? `Rp${item.spk
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
                  : ''
              }}</td
            >
            <td
              v-if="
                item.spk !== null ||
                  (item.proyek_id_header === null && item.id_header === null)
              "
              class="text-right"
              :rowspan="item.rowspan_spk"
            >
              {{
                item.spk !== null
                  ? `Rp${(
                      item.spk *
                      (item.spk_kali !== 'all'
                        ? item[item.spk_kali]
                        : item.volume * item.periode)
                    )
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
                  : ''
              }}</td
            >
          </tr>
          <tr>
            <td class="text-center"></td>
            <td class="th-td-35"></td>
            <td class="text-center"></td>
            <td class="text-center"></td>
            <td class="text-center"></td>
            <td class="text-right">Total SPH</td>
            <td class="text-right"
              >Rp{{
                items
                  .reduce(
                    (a, b) =>
                      a +
                      (b['sph'] *
                        (b['sph_kali'] !== 'all'
                          ? b[b['sph_kali']]
                          : b['volume'] * b['periode']) || 0),
                    0
                  )
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              }}</td
            >
            <td class="text-right">Total SPK</td>
            <td class="text-right"
              >Rp{{
                items
                  .reduce(
                    (a, b) =>
                      a +
                      (b['spk'] *
                        (b['spk_kali'] !== 'all'
                          ? b[b['spk_kali']]
                          : b['volume'] * b['periode']) || 0),
                    0
                  )

                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              }}</td
            >
          </tr>
          <tr>
            <td colspan="8" class="text-right">Margin</td>
            <td class="text-right"
              >Rp{{
                margin.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              }}</td
            >
          </tr>
          <tr>
            <td colspan="8" class="text-right">Margin (Presentase)</td>
            <td class="text-right">{{ marginPresentase }}</td>
          </tr>
        </tbody>
      </table>
      <table style="width: 100%; border: 0px">
        <tbody>
          <tr style="border: none">
            <td style="border: none; width: 4%"></td>
            <td style="border: none; width: 32%">Mengetahui dan Menyetujui,</td>
            <td style="border: none; width: 32%">Mengetahui,</td>
            <td style="border: none; width: 32%">Hormat Saya</td>
          </tr>
          <tr style="border: none">
            <td style="padding-top: 70px; border: none; width: 4%"></td>
            <td
              style="
                padding-top: 70px;
                border: none;
                width: 32%;
                text-decoration: underline;
              "
              >{{ detail.ketua }}</td
            >
            <td
              style="
                padding-top: 70px;
                border: none;
                width: 32%;
                text-decoration: underline;
              "
              >{{ detail.sekretaris }}</td
            >
            <!-- <td
              style="
                padding-top: 70px;
                border: none;
                width: 18%;
                text-decoration: underline;
              "
              colspan="2"
              >{{ detail.kabid_kemitraan }}</td
            > -->
            <td
              style="
                padding-top: 70px;
                border: none;
                width: 32%;
                text-decoration: underline;
              "
              >{{ detail.kabag_kemitraan }}</td
            >
          </tr>
          <tr style="border: none">
            <td style="border: none; width: 4%"></td>
            <td style="border: none; width: 32%">Ketua</td>
            <td style="border: none; width: 32%">Sekretaris</td>
            <!-- <td style="border: none; width: 18%" colspan="2">Kabid Kemitraan</td> -->
            <td style="border: none; width: 32%">Manager Usaha</td>
          </tr>
        </tbody>
      </table>
      <template v-slot:modal-footer>
        <a href="javascript:window.print()" class="btn btn-primary">
          <i class="uil uil-print mr-1"></i> Print
        </a>
      </template>
    </b-modal>
  </div>
</template>

<style>
/* =========================================
   PROJECT INFORMATION
========================================= */

.project-info-table {
  font-size: 13px;
  margin-bottom: 0;
  border-collapse: collapse;
}

.project-info-table td {
  border: 1px solid #dee2e6 !important;
  font-size: 11px;
  vertical-align: middle;
}

.project-info-label {
  width: 40%;
  padding: 8px 16px !important;
  color: #6c757d;
  font-weight: 600;
  background-color: #f8f9fa !important;
}

.project-info-value {
  padding: 8px 16px !important;
  font-weight: 700;
  font-size: 12px;
  background-color: #ffffff;
}
/* =========================================
   RAB TABLE WRAPPER
========================================= */

.rab-table-wrapper {
  overflow: auto;
  max-height: 600px;
  position: relative;
}

/* =========================================
   RAB TABLE
========================================= */

.rab-table {
  border-collapse: separate !important;
  border-spacing: 0 !important;
  width: 100%;
  min-width: 1050px;
  font-size: 13px;

  /* hilangkan border bawaan table */
  border: 0 !important;
}

/* =========================================
   CELL BORDER
========================================= */

/*
 * Border dibuat custom supaya:
 * - tetap terlihat
 * - sangat tipis
 * - tidak setebal Bootstrap table-bordered
 */

.rab-table th,
.rab-table td {
  padding: 8px 10px;

  background-color: #ffffff;

  white-space: nowrap;
  vertical-align: middle;

  border: 0 !important;

  border-right: 1px solid #dee2e6 !important;
  border-bottom: 1px solid #dee2e6 !important;
}

/*
 * Border kiri tabel
 */

.rab-table th:first-child,
.rab-table td:first-child {
  border-left: 1px solid #dee2e6 !important;
}

/*
 * Border atas tabel
 */

.rab-table thead tr:first-child th {
  border-top: 1px solid #dee2e6 !important;
}

/* =========================================
   HEADER
========================================= */

.rab-table .header-lvl-1 th,
.rab-table .header-lvl-2 th {
  position: sticky;

  background-color: #f8f9fa !important;

  border-right: 1px solid #e9ecef !important;
  border-bottom: 1px solid #e9ecef !important;

  font-weight: 600;
  color: #343a40;

  z-index: 20;
}

.rab-table .header-lvl-1 th {
  top: 0;
}

.rab-table .header-lvl-2 th {
  top: 37px;
}

/* =========================================
   STICKY NO
========================================= */

.rab-table .sticky-col-1 {
  position: sticky;

  left: 0;

  width: 50px;
  min-width: 50px;

  background-color: #ffffff !important;

  z-index: 10;
}

/* =========================================
   STICKY URAIAN
========================================= */

.rab-table .sticky-col-uraian {
  position: sticky;

  left: 50px;

  width: 280px;
  min-width: 280px;
  max-width: 400px;

  white-space: normal !important;

  background-color: #ffffff !important;

  box-shadow: 3px 0 5px -5px rgba(0, 0, 0, 0.35);

  z-index: 10;
}

/* =========================================
   STICKY ACTION
========================================= */

.rab-table .sticky-col-last {
  position: sticky;

  right: 0;

  width: 115px;
  min-width: 115px;

  background-color: #ffffff !important;

  box-shadow: -3px 0 5px -5px rgba(0, 0, 0, 0.35);

  z-index: 10;
}

/* =========================================
   STICKY HEADER
========================================= */

.rab-table thead .sticky-col-1,
.rab-table thead .sticky-col-uraian,
.rab-table thead .sticky-col-last {
  background-color: #f8f9fa !important;

  z-index: 30;
}

/* =========================================
   HOVER
========================================= */

.rab-table tbody tr:hover td {
  background-color: #fafbfc !important;
}

.rab-table tbody tr:hover .sticky-col-1,
.rab-table tbody tr:hover .sticky-col-uraian,
.rab-table tbody tr:hover .sticky-col-last {
  background-color: #fafbfc !important;
}

.rab-table tbody tr:hover .sticky-col-uraian {
  box-shadow: 3px 0 5px -4px rgba(0, 0, 0, 0.3);
}

/* =========================================
   TOTAL
========================================= */

.rab-table .rab-total-row td {
  background-color: #f8f9fa !important;

  font-weight: 600;

  border-right: 1px solid #dee2e6 !important;
  border-bottom: 1px solid #dee2e6 !important;
  border-top: 1px solid #e9ecef !important;
}

.rab-table .rab-total-row .sticky-col-1,
.rab-table .rab-total-row .sticky-col-uraian,
.rab-table .rab-total-row .sticky-col-last {
  background-color: #f8f9fa !important;
}

/* =========================================
   ACTION BUTTON
========================================= */

.rab-table .btn {
  line-height: 1.5;
}

/* =========================================
   RESPONSIVE
========================================= */

@media (max-width: 768px) {
  .rab-table {
    font-size: 12px;
  }

  .rab-table th,
  .rab-table td {
    padding: 6px 8px;
  }

  .rab-table .sticky-col-uraian {
    width: 220px;
    min-width: 220px;
  }

  .rab-table .sticky-col-last {
    width: 100px;
    min-width: 100px;
  }
}

/* =========================================
   PRINT
========================================= */

@media print {
  .rab-table-wrapper {
    overflow: visible;
    max-height: none;
  }

  .rab-table {
    min-width: 0;
  }

  .rab-table .sticky-col-1,
  .rab-table .sticky-col-uraian,
  .rab-table .sticky-col-last {
    position: static;
    box-shadow: none;
  }
}
</style>
